import { useQuery } from '@tanstack/react-query';
import * as analyticsApi from '@/api/analytics';
import type { RangeParam } from '@/types/analytics';

const STALE_TIME = 60_000;

export function useOverviewAnalytics(range: RangeParam = '30d', teacherId?: string) {
  return useQuery({
    queryKey: ['analytics', 'overview', range, teacherId ?? null],
    queryFn: () => analyticsApi.getOverviewAnalytics(range, teacherId),
    staleTime: STALE_TIME,
  });
}

export function useStudentAnalytics(studentId: string, range: RangeParam = '30d') {
  return useQuery({
    queryKey: ['analytics', 'student', studentId, range],
    queryFn: () => analyticsApi.getStudentAnalytics(studentId, range),
    enabled: !!studentId,
    staleTime: STALE_TIME,
  });
}

export function useTeacherAnalytics(teacherId: string, range: RangeParam = '30d') {
  return useQuery({
    queryKey: ['analytics', 'teacher', teacherId, range],
    queryFn: () => analyticsApi.getTeacherAnalytics(teacherId, range),
    enabled: !!teacherId,
    staleTime: STALE_TIME,
  });
}
